import api from './axios';

// user 서버 전송
export const userSend = async ( path, sendData ) => {
    const sendPath = '/knouUser' + path;
    const response = await api.post(sendPath, sendData );
    return response.data;
};

// 관리자 서버 전송
export const admSend = async ( path, sendData ) => {
    const sendPath = '/knouAdm' + path;
    const response = await api.post(sendPath, sendData );
    return response.data;
};

// 관리자 서버 전송
export const mngSend = async ( path, sendData ) => {
    const sendPath = '/knouMng' + path;
    const response = await api.post(sendPath, sendData );
    return response.data;
};

// GET /users
export const fetchUsers = async () => {
  const response = await api.get('/knouUser/allMemberList');
  return response.data;
};

// GET /users/:id
export const fetchUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

// POST /users
export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

// PUT /users/:id
export const updateUser = async (id, updatedData) => {
  const response = await api.put(`/users/${id}`, updatedData);
  return response.data;
};

// DELETE /users/:id
export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};